import { createAppStore } from '@store/createAppStore';
import { PricingState } from '@store/customers/customerDetails/pricingTab';

const [pricingStore, setPricingStore] = createAppStore<PricingState>(
  {
    isLoading: false,
    isError: false,
    errorMessage: '',
    isPricingEnabled: false,
    isPricingEnabledError: false,
    items: [],
  },
  'pricingStore',
);

export { pricingStore, setPricingStore };
